/**
 * Update the share label text and activate the target element.
 *
 * @param {HTMLElement} target Target element.
 * @param {string} text New label text.
 */
export function updateLabel( target, text ) {
	const label = target.querySelector( '.entry-meta__share-label' );
	if ( ! label ) {
		return;
	}

	label.textContent = text;
	target.classList.add( 'active' );

}
